import React, { useContext, useEffect } from "react";
import { InvestTransactionContext } from "./contexts/InvestTransactionContext";
import { InvestCalculationContext } from "./contexts/InvestCalculationContext";

import { Typography,Stack,Box } from "@mui/material";
import CustomIcon from "../../../../components/customIcon";
import { InvestCardComponent } from "./InvestCardComponent";
import { TooltipComponent } from "./tooltipComponent";

export const OwnershipCard = React.memo(() => {
    const { listing, selectedMode, setMode, transaction } = useContext(InvestTransactionContext);
    const { minCoOwnAmount, minAmount, maxAmount } = useContext(InvestCalculationContext);
    const ownerShipModes = [
        {
            title: "Asset Tokens",
            subtitle: "Right to Asset Co-Ownership + Full benefits + Better Liquidity + Low min investment",
            icon: "token",
            info: <Typography variant="caption" color={"text.primary"}>
                Legal Contract giving you Right To Registered Co-ownership, recorded on Blockchain and issued as Asset NFT. Carries all benefits of Co-Owner + better liquidity + smaller investment amount.
                <br />
                <a href="https://www.realx.in/how-it-works?tab=1" target="_blank">Read more about Asset Ownership Modes</a>
            </Typography>,
            id: 0,
            disabled: false,
            visible: listing?.tokenisation,
        },
        {
            title: "Registered Co-ownership",
            subtitle: "Get your name as per registered property document",
            icon: "ownership",
            info: <Typography variant="caption" color={"text.primary"}>
                You become a registered co-owner of the property, commonly registered by the custodian on behalf of you as well as other co-owners.
                <br />
                {/* <Link component={RouterLink} to={"/how-it-works?tab=1"} target={"_blank"} state={{tab:1}}>Read more about Property Ownership Modes</Link> */}
                <a href="https://www.realx.in/how-it-works?tab=1" target="_blank">Read more about Property Ownership Modes</a>
            </Typography>,
            id: 1,
            disabled: maxAmount < minCoOwnAmount || listing?.status == "PRECLOSED",
            visible: listing?.ownership,
        }
    ]
    useEffect(() => {
        // console.log(listing,"tesssttt")
        if (listing && !listing?.tokenisation) {
            setMode(1);
        }
    }, [minCoOwnAmount, minAmount, maxAmount, listing])

    return (
        <InvestCardComponent title={`${!transaction ? "Select" : ""} Ownership Type`}>
            <Stack spacing={"10px"}>
                {
                    ownerShipModes.filter((k) => k.visible).map((e) => {
                        if (transaction) {
                            if (e.id === selectedMode) {
                                return (
                                    <Box
                                        onClick={() => setMode(e.id)}
                                        sx={{
                                            maxWidth: 440,
                                            padding: "14px 20px",
                                            border: "1px solid",
                                            borderColor: selectedMode === e.id ? "primary.main" : "divider",
                                            borderRadius: 1,
                                            bgcolor: selectedMode === e.id ? "primary.light" : "transparent",
                                            cursor: "pointer",
                                        }}
                                    >
                                        <Stack direction={"row"} spacing={2} alignItems={"center"}>
                                            <Box
                                                sx={{
                                                    width: 30,
                                                    height: 30,
                                                    minWidth: 30,
                                                    borderRadius: 0.5,
                                                    border: "1px solid",
                                                    bgcolor: selectedMode === e.id ? "primary.main" : "transparent",
                                                    borderColor: selectedMode === e.id ? "primary.main" : "primary.light",
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                }}
                                            >
                                                <CustomIcon name={e.icon} sx={{ bgcolor: selectedMode === e.id ? "white" : "primary.main" }} />
                                            </Box>
                                            <Stack direction={"column"}>
                                                <Stack direction={"row"} alignItems={"center"} spacing={1.5}>
                                                    <Typography variant="body1" sx={{ fontWeight: 500 }}>{e.title}</Typography>
                                                    <TooltipComponent info={e.info} />
                                                </Stack>
                                                <Typography variant="caption" sx={{ fontWeight: 300 }}>{e.subtitle}</Typography>
                                            </Stack>
                                        </Stack>
                                    </Box>
                                )
                            }
                            else return "";
                        }
                        else {
                            return (
                                <Box
                                    onClick={() => e.disabled ? {} : setMode(e.id)}
                                    sx={{
                                        maxWidth: 440,
                                        padding: "14px 20px",
                                        border: "1px solid",
                                        borderColor: selectedMode === e.id ? "primary.main" : "divider",
                                        borderRadius: 1,
                                        bgcolor: selectedMode === e.id ? "primary.light" : "transparent",
                                        cursor: "pointer"
                                    }}
                                >
                                    <Stack direction={"row"} spacing={2} alignItems={"center"}>
                                        <Box
                                            sx={{
                                                width: 30,
                                                height: 30,
                                                minWidth: 30,
                                                borderRadius: 0.5,
                                                border: "1px solid",
                                                bgcolor: selectedMode === e.id ? "primary.main" : "transparent",
                                                borderColor: selectedMode === e.id ? "primary.main" : "primary.light",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center"
                                            }}
                                        >
                                            <CustomIcon name={e.icon} sx={{ bgcolor: e.disabled ? "text.disabled" : selectedMode === e.id ? "white" : "primary.main" }} />
                                        </Box>
                                        <Stack direction={"column"}>
                                            <Stack direction={"row"} alignItems={"center"} spacing={1.5}>
                                                <Typography variant="body1" sx={{ fontWeight: 500, color: e.disabled ? "text.disabled" : "" }}>{e.title}</Typography>
                                                <TooltipComponent disabled={e.disabled} info={e.info} />
                                            </Stack>
                                            <Typography variant="caption" sx={{ fontWeight: 300, color: e.disabled ? "text.disabled" : "" }}>{e.subtitle}</Typography>
                                        </Stack>
                                    </Stack>
                                </Box>
                            )
                        }
                    })
                }
            </Stack>
        </InvestCardComponent>
    );
})